var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data&&_vm.data.length>0&&_vm.userInfo.isShowFlow==1)?_c('div',{staticClass:"tree"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding:10px;border:1px solid #E4E7ED"}},[_c('processTree',{attrs:{"data":_vm.data},on:{"clickitem":_vm.clickitem}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }